import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import SiteShell from "@/components/SiteShell";
import SEO from "@/components/SEO";
import api from "@/lib/api";

export default function BlogList() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog").then(({ data }) => setPosts(data.posts || [])).catch(() => {}); }, []);

  return (
    <SiteShell>
      <SEO title="Blog & Insights — Saans Wellness" path="/blog"
        description="Guides and insights on Ayurvedic & nutraceutical PCD franchise, third-party manufacturing and building a wellness business in India." />
      <section className="bg-[#f9f8f5] pt-32 pb-16 md:pt-40" data-testid="blog-list-page">
        <div className="mx-auto max-w-7xl px-5 md:px-8">
          <div className="max-w-2xl">
            <div className="eyebrow text-[#d46a1d]">Blog & Insights</div>
            <h1 className="mt-3 font-serif text-4xl tracking-tight text-[#202124] md:text-5xl">Guides for building your wellness business</h1>
            <p className="mt-4 text-lg text-[#55534e]">Practical advice on PCD franchise, manufacturing and growing an Ayurvedic & nutraceutical brand.</p>
          </div>

          <div className="mt-12 grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {posts.length === 0 && <p className="text-[#6b6a65]">No posts yet.</p>}
            {posts.map((p, i) => (
              <motion.article key={p.slug}
                initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
                transition={{ duration: 0.5, delay: (i % 3) * 0.07 }}
                className="group overflow-hidden rounded-2xl border border-[#e7e0d6] bg-white card-shadow" data-testid={`blog-card-${i}`}>
                <Link to={`/blog/${p.slug}`}>
                  {p.cover_image && (
                    <div className="aspect-[16/10] overflow-hidden bg-[#f2ece4]">
                      <img src={p.cover_image} alt={p.title} loading="lazy" decoding="async"
                        className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                    </div>
                  )}
                  <div className="p-6">
                    {p.tags && <div className="text-xs font-semibold uppercase tracking-wide text-[#1f5d3a]">{p.tags.split(",")[0]}</div>}
                    <h2 className="mt-2 font-serif text-xl text-[#202124]">{p.title}</h2>
                    <p className="mt-2 line-clamp-3 text-sm leading-relaxed text-[#6b6a65]">{p.excerpt}</p>
                    <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-[#d46a1d]">Read more <ArrowUpRight size={15} /></span>
                  </div>
                </Link>
              </motion.article>
            ))}
          </div>
        </div>
      </section>
    </SiteShell>
  );
}
